<template>
  <nk-page commercialAccess="System" :policyClaims="{ or: ['Accounting_FloatingCenters_Add', 'Accounting_FloatingCenters_Edit'] }" :buttons="[componentOptions.buttons.metaDataBtn]">
    <template #badges>
      <nk-badge system="accounting">
        <nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
      </nk-badge>
    </template>

    <div class="container-fluid h-100" ref="parent">
      <div class="row flex-row-reverse">
        <div class="col-12 form-container">
          <nk-stabs :activeTab="'basic-info'" class="nk-card">
            <nk-stab :id="'basic-info'" :name="$t('center.basic-information')">
              <div class="row">
                <div class="col-12 col-lg-12 col-xl-12">
                  <div class="row mobile">
                    <div class="col-sm-8 col-12">
                      <div class="row">
                        <div class="col-12">
                          <nk-col-form-group :label="$t('center.f.active') + ':'" :labelSizes="{ sm: 3, xs: 3 }" :dataSizes="{ sm: 9, xs: 9 }">
                            <nk-switch v-model="localData.isEnabled" :tabindex="100"></nk-switch>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12">
                          <nk-col-form-group :label="$t('center.f.accountingCode') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <div class="row no-gutters">
                              <div :class="[data.parentData ? 'col-6' : 'col']">
                                <nk-input ref="code" v-model="localData.code" @searchClick="allCenters" @blur="centerCodeBlur" :options="componentOptions.code" :tabindex="101" startup></nk-input>
                              </div>
                              <div class="col-6" v-if="data.parentData">
                                <div class="form-control form-control-sm is-label text-right" readonly v-html="accountingCode">
                                </div>
                              </div>
                            </div>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12 col-sm-12">
                          <nk-col-form-group :label="$t('center.f.group') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <div class="row no-gutters floating-center-input">
                              <div class="col-12 col-md-12 p-0">
                                <div class="d-flex">
                                  <nk-dropdown :data="centerGroups" :disabled="(data.state != 'add-root' && data.parentData != null || (centerGroups.length === 1 && settings.group.length)) ? true : null" class="floating-center-group-drop" ref="CenterGroupDrp" v-model="localCentergroup" :options="componentOptions.group" :tabindex="102"></nk-dropdown>
                                </div>
                              </div>
                            </div>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12">
                          <nk-col-form-group :label="$t('center.higher-level') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <nk-dropdown-center v-model="localData.parent" :disabled="!settings.allowParents" @update:modelValue="parentChanged" :options="parentDropdownOptions" :tabindex="103">
                            </nk-dropdown-center>
                          </nk-col-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-sm-12">
                          <nk-col-form-group :label="$t('center.f.name') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <nk-input v-model="localData.name" :options="componentOptions.name" :tabindex="104" ref="centerName">
                            </nk-input>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12 col-sm-12">
                          <nk-col-form-group :label="$t('center.f.floatingCenterCategory') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <nk-dropdown-category v-model="localData.floatingCenterCategory" :options="componentOptions.category" ref="centerCategory" :tabindex="105">
                            </nk-dropdown-category>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12 col-sm-12">
                          <nk-col-form-group :label="$t('center.f.priceLevel') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
                            <nk-dropdown-product-price-level v-model="priceLevel" :options="componentOptions.priceLevel" ref="centerPriceLevel" :tabindex="106">
                            </nk-dropdown-product-price-level>
                          </nk-col-form-group>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 col-12">
                      <div class="image-container col-6">
                        <nk-image-uploader ref="imageUploader" :modelValue="getProfile(localData)" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" style="padding-right: 12px;">
                      <nk-col-form-group :label="$t('center.f.description') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 10 }">
                        <nk-textarea :rows="5" :tabindex="107" v-model="localData.description"></nk-textarea>
                      </nk-col-form-group>
                    </div>
                  </div>
                </div>
              </div>

            </nk-stab>
            <nk-stab :id="'link-to-account'" :name="$t('center.link-to-account')">
              <div class="row">
                <div class="col-12">
                  <nk-table class="h-grow-lock" v-model="selectDetailRow" :data="linkedAccounts" :options="componentOptions.table" tabindex="200" ref="table"></nk-table>
                </div>
              </div>
            </nk-stab>
          </nk-stabs>
          <nk-stabs :activeTab="'advance-info'" class="nk-card">
            <nk-stab :id="'advance-info'" :name="$t('center.center-advanced-info')">
              <div class="row">
                <div class="col-12 col-lg-12 col-xl-12">
                  <nk-metadata ref="metaDataList" :tabindex="108" :options="metaDataListOptions" />
                  <div v-if="!retreiveIsEmpty()">
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <nk-col-form-group :label="$t('center.f.debtorReliability') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                          <nk-label style="direction:ltr;" readonly :options="componentOptions.priceLabel" class="form-control form-control-sm" :modelValue="localData.debtorReliability"> &nbsp;</nk-label>
                        </nk-col-form-group>
                      </div>
                      <div class="col-12 col-sm-6">
                        <nk-col-form-group :label="$t('center.f.creditorReliability') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                          <nk-label style="direction:ltr;" readonly :options="componentOptions.priceLabel" class="form-control form-control-sm" :modelValue="localData.creditorReliability"> &nbsp;</nk-label>
                        </nk-col-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <nk-col-form-group :label="$t('center.f.debtorReliabilityExcChange') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                          <nk-label style="direction:ltr;" readonly :options="componentOptions.priceLabel" class="form-control form-control-sm" :modelValue="localData.debtorReliabilityExcChange"> &nbsp;</nk-label>
                        </nk-col-form-group>
                      </div>
                      <div class="col-12 col-sm-6">
                        <nk-col-form-group :label="$t('center.f.creditorReliabilityExcChange') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                          <nk-label style="direction:ltr;" readonly :options="componentOptions.priceLabel" class="form-control form-control-sm" :modelValue="localData.creditorReliabilityExcChange"> &nbsp;</nk-label>
                        </nk-col-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="isPersonnel">
                    <div class="col-12 col-sm-6">
                      <nk-col-form-group :label="$t('center.f.marketingRoles.title') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="col-12">
                              <nk-checkbox type="checkbox" :options="componentOptions.marketer" :modelValue="hasRole('Marketing')" @update:modelValue="val => toggleRole('Marketing', val)" />
                            </div>
                            <div class="col-12">
                              <nk-checkbox type="checkbox" :options="componentOptions.distributionAgent" :modelValue="hasRole('DistributionAgent')" @update:modelValue="val => toggleRole('DistributionAgent', val)" />
                            </div>
                            <div class="col-12">
                              <nk-checkbox type="checkbox" :options="componentOptions.collectorAgent" :modelValue="hasRole('CollectorAgent')" @update:modelValue="val => toggleRole('CollectorAgent', val)" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="col-12">
                              <nk-checkbox type="checkbox" :options="componentOptions.assessorAgent" :modelValue="hasRole('AssessorAgent')" @update:modelValue="val => toggleRole('AssessorAgent', val)" />
                            </div>
                            <div class="col-12">
                              <nk-checkbox type="checkbox" :options="componentOptions.hotSeller" :modelValue="hasRole('HotSeller')" @update:modelValue="val => toggleRole('HotSeller', val)" />
                            </div>
                          </div>
                        </div>
                      </nk-col-form-group>
                    </div>
                    <div class="col-12 col-sm-6">
                      <nk-col-form-group :label="$t('center.f.commissionCalculationType.title') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
                        <nk-dropdown v-model="localData.commissionCalculationType" :data="commissionCalculationTypes" :options="componentOptions.calculationType"></nk-dropdown>
                      </nk-col-form-group>
                      <div class="row mt-2">
                        <div class="col-12 col-sm-6">
                          <nk-col-form-group :label="$t('center.f.commissionCalculationType.commissionFixedAmount') + ':'" :labelAligns="{ lg: 'right', md: 'right', sm: 'right' }">
                            <nk-input v-model="localData.fixAmountOfCommission" :options="{ mode: 'price' }"></nk-input>
                          </nk-col-form-group>
                        </div>
                        <div class="col-12 col-sm-6">
                          <nk-col-form-group :label="$t('center.f.commissionCalculationType.commissionFixedPercentage') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
                            <nk-input v-model="localData.fixPercentageOfCommission" :options="componentOptions.percent"></nk-input>
                          </nk-col-form-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nk-stab>
          </nk-stabs>
        </div>
      </div>
    </div>
  </nk-page>
</template>
<script>
  import _ from 'lodash'
  import { post, get } from '~/plugins/nikan-api'
  import { mapActions, mapGetters } from 'vuex'
  import $sc from '~/plugins/shortcut.collection.js'
  import centerSelector from './center-selector'
  import dialog from '~/plugins/nikan-dialog-plugin'
  import validators, { Checker, MetaDataChecker, VIranNationalCode, isEmpty } from '~/statics/validators'
  import Endpoints from '@nikan/endpoints'
  import MetaDataSchemaModify from '~/components/form/meta-data/meta-data-schema-modify.vue'
  import DropdownAccount from '~/components/form/dropdown/dropdown-account.vue'
  import Input from '~/components/general/nikan-input.vue'
  import AccountList from '~/views/accounts/account-selector.vue'
  import UpdateCode from '@/components/form/salary/personnel/update-code.vue'
  import { CommissionCalculationType } from '@/enums/sale'

  export default {
    modal: {
      size: 'lg',
      stateUID: 'floating-center-modify',
      helpTag: 'FloatingCenterModify'
    },
    props: {
      data: { type: Object, required: true },
      options: { type: Object, required: false },
    },
    data() {
      return {
        priceLevel: null,
        localData: null,
        selectDetailRow: null,
        linkedAccounts: [],
        parentsData: [],
        commissionCalculationTypes: Object.values(CommissionCalculationType),
        componentOptions: {
          table: {
            stateUID: 'center-modify-link-to-account',
            multiselection: false,
            addNewRowOnInit: false,
            editable: true,
            itemSize: 30,
            alwaysEmit: true,
            allowNewRow: true,
            buttons: {
              addBtn: {
                options: {
                  visible: true
                }
              },
              deleteBtn: {
                options: {
                  visible: true,
                }
              },
              selectFromAccountList: {
                handler: this.allAcocunts,
                displayOrder: 3,
                class: "no-outline",
                type: 'nk-btn',
                options: {
                  hideTitle: true,
                  title: this.$t('center.buttons.account-list'),
                  icon: 'list-ul',
                }
              }
            },
            columns: [
              {
                name: 'rowNumber',
                title: this.$t('row-number'),
                searchable: true,
                sortable: true,
                resizable: true,
                pinnable: false,
                pinned: false,
                width: 60,
                entering: false,
                aggregates: [
                  {
                    type: 'count'
                  },
                ],
              },
              {
                name: 'account',
                title: this.$t('center.f.account'),
                search: {
                  searchFields: ['name', 'code'],
                },
                validators: validators('required'),
                view: {
                  options: {
                    format: (item) => `${item.name} (${item.accountingCode})`,
                  },
                },
                edit: (row, col) => {
                  return {
                    component: DropdownAccount,
                    options: {
                      accountSelectorButton: true,
                      loadOnMount: false,
                      showSelectedBalance: false,
                    },
                  }
                },
                searchable: true,
                sortable: false,
                editable: true,
                align: 'right',
                leaving: true,
                entering: true,
                width: 'auto',
              },
              {
                name: 'centerLevel',
                title: this.$t('center.f.link-center-level'),
                searchable: true,
                sortable: true,
                editable: (row, col) => { return row.rowState === 'new' },
                entering: (row, col) => { return row.rowState === 'new' },
                pinned: false,
                pinnable: true,
                resizable: true,
                width: '135px',
                validators: validators('required'),
                edit: {
                  component: Input,
                  options: {
                    mode: 'integer',
                  },
                }
              }
            ]
          },
          buttons: {
            metaDataBtn: {
              icon: 'list-ul',
              handle: (button, page, e) => {
                this.metaDataModal()
              },
              isPrimary: true,
              policyClaims: 'General_MetaDataSchema_Management'
            },
          },
          code: {
            mode: 'code',
            code: {
              level: 1,
              length: 1,
            },
            required: true,
            searchable: true,
            onSearchClick: this.allCenters,
          },
          percent: {
            mode: 'percent',
            icon: 'percent',
          },
          calculationType: {
            searchable: true,
            required: true,
            remoteSearch: false,
            placeholder: this.$t('select-it'),
            searchableFields: ['key'],
            display: function (item) {
              return this.$t('center.f.commissionCalculationType.' + item.toLowerCase())
            },
          },
          name: {
            required: true,
          },
          category: {
            type: null,
            selectable: true
          },
          priceLevel: {
            selectable: true,
            placeholder: this.$t('select-it'),
          },
          priceLabel: {
            type: 'price',
          },
          marketer: {
            title: this.$t('center.f.marketingRoles.marketer')
          },
          distributionAgent: {
            title: this.$t('center.f.marketingRoles.distributionAgent')
          },
          collectorAgent: {
            title: this.$t('center.f.marketingRoles.collectorAgent')
          },
          assessorAgent: {
            title: this.$t('center.f.marketingRoles.assessorAgent')
          },
          hotSeller: {
            title: this.$t('center.f.marketingRoles.hotSeller')
          },
          group: {
            searchable: true,
            required: true,
            placeholder: this.$t('select-it'),
            display: (item) => {
              let val = (item.key || 'undefined').toString().toLowerCase()
              return `${this.$t('FloatingCenterGroups.' + val)} (${this.$t('center.selector.table.c.code')}: ${item.value})`
            },
            remoteSearch: false,
            searchPrefix: 'FloatingCenterGroups',
            searchableFields: ['key', 'name'],
          },
        },
        settings: {
          group: [],
          allowParents: false,
        },
        dropdownData: {
          position: [
            { id: 1, name: 1 },
            { id: 2, name: 2 },
            { id: 3, name: 3 },
            { id: 4, name: 4 },
            { id: 5, name: 5 },
            { id: 6, name: 6 },
            { id: 7, name: 7 },
            { id: 8, name: 8 },
            { id: 9, name: 9 },
            { id: 10, name: 10 },
            { id: 11, name: 11 },
            { id: 12, name: 12 },
            { id: 13, name: 13 },
            { id: 14, name: 14 },
            { id: 15, name: 15 },
            { id: 16, name: 16 },
          ],
        },
        originalCenter: null,
        centerGroups: [],
        onCodeEnterPressed: false,
        saveCenterButton: {
          title: this.$t('save'),
          shortcut: $sc.find('save'),
          isPrimary: true,
          icon: 'save',
          handle: (button, page, e) => {
            e.preventDefault()
            this.save()
              .then((res) => this.resolve(this.localData))
              .catch(err => { })
          },
          policyClaims: { or: ['Accounting_FloatingCenters_Add', 'Accounting_FloatingCenters_Edit'] },
        },
        changeCodeButton: {
          title: this.$t('changeCode.title'),
          shortcut: $sc.find('edit'),
          isPrimary: true,
          disabled: true,
          icon: 'code',
          handle: (button, page, e) => {
            e.preventDefault()
            this.showModal({
              component: UpdateCode,
              options: {
                claim: 'Accounting_FloatingCenters_Edit',
                commercialAccess: 'System',
              },
              data: { code: this.localData.code }
            }).then(res => {
              const originalCode = this.localData.code
              this.localData.code = res.code
              this.save()
                .then((res) => { this.resolve(this.localData) })
                .catch(err => { this.localData.code = originalCode })
            }).catch(err => { })

          },
          policyClaims: { or: ['Accounting_FloatingCenters_Edit'] },
        },
        saveAndNewCenterButton: {
          title: this.$t('save-new'),
          shortcut: $sc.find('save-new'),
          isPrimary: true,
          icon: 'file',
          handle: (button, page, e) => {
            e.preventDefault()
            this.save()
              .then((res) => {
                this.clearForm()
              })
              .catch(err => { })
          },
          policyClaims: { or: ['Accounting_FloatingCenters_Add', 'Accounting_FloatingCenters_Edit'] },
        },
        validators: {
          accountingCode: validators('required'),
          name: validators('required'),
          group: validators('required'),
          // floatingCenterCategory: validators('required'),
        },
        metaDataValidators: {
          Center_NationalCode: validators('required', new VIranNationalCode()),
        }
      }
    },
    computed: {
      ...mapGetters({
        metaDataList: 'metadata/schemas',
        getProfile: 'floatingCenters/getCenterProfile',
        getAllCenters: 'floatingCenters/all',
        allProperties: 'properties/all',
        getAccountbyId: 'accounts/getById',
        getCommercialAccess: 'appContext/getCommercialAccess'
      }),
      centerPosition: {
        get() {
          if (!isNaN(this.localData.position)) {
            return {
              id: this.localData.position,
              name: this.localData.position,
            }
          }

          return undefined
        },
        set(selected) {
          if (selected) {
            this.localData.position = selected.id
          }
        },
      },
      localCentergroup: {
        get() {
          return _.head(
            this.centerGroups.filter(
              (x) => _.toLower(x.key) == _.toLower(this.localData.group) && this.$nikan.checkPermission(`Accounting_FloatingCenterGroups_${x.key}`)
            )
          )
        },
        set(obj) {
          if (!obj) {
            this.localData.group = ''
            this.prepareParentsData()
          } else {
            this.localData.group = obj.key
            this.prepareParentsData(obj.key)
          }
        },
      },
      isPersonnel() {
        return this.localCentergroup?.key === 'Personel'
      },
      accountingCode() {
        if (!this.localData) return ''

        if (String(this.localData.code).indexOf('-') > -1)
          return this.localData.code

        return this.localData.parent
          ? String(`${this.localData.parent.accountingCode}-${this.localData.code}`)
          : this.localData.code
      },
      parentData() {
        return this.localData.parent
          ? `${this.localData.parent.name} (&#x200E;${this.localData.parent.accountingCode})`
          : ''
      },
      parentAccountingCode() {
        return this.localData.parent ? this.localData.parent.accountingCode : ''
      },
      metaDataListOptions() {
        return {
          subject: (this.localCentergroup || {}).key,
          data: this.localData.metaDatas || [],
          prefix: 'Center'
        }
      },
      parentDropdownOptions() {
        return {
          rowIdentifier: 'id',
          searchable: true,
          required: true,
          baseAccountId: null,
          centerLevel: 0,
          remoteSearch: false,
          placeholder: this.$t('autoAccount.choose-center'),
          display: (item) => `${item.accountingCode} - ${item.name}`,
          searchableFields: ['name', 'accountingCode'],
          loadAllIfBaseAccountIsEmpty: true,
          showIfRelatedAccountIsEmpty: true,
          linkNewCenterToAccount: false,
          group: this.localData.group ? [this.localData.group] : null,
          excludeCenterIds: this.localData.id ? [this.localData.id] : null,
          hasChild: true
        }
      }
    },
    created() {
      this.localData = this.data.nodeData
    },
    mounted() {

      this.settings = _.merge(this.settings, this.options)
      this.settings.allowParents = isEmpty(this.localData?.balance) && !isEmpty(this.localData.parentData) || this.settings.allowParents

      if (this.data.state != 'add-root' && this.localData.parentData != null) {
        this.localData.floatingCenterCategory = this.data.parentData.floatingCenterCategory
        this.localData.group = this.localData.parentData.group
      }

      if (this.settings.allowParents) {
        this.prepareParentsData(this.localData.group)
      }

      this.getCenterDetails(this.localData.accountingCode, this.localData.parent).then((res) => {
        this.getProperties()
        this.defer(() => this.focusOnInput(), 300) // 300 because when this form open by group filter such as bank, fill bank after 200 ms in getProperties method
      })
      var title = this.data.state.indexOf('add') > -1 ? 'center.new-center' : 'center.edit-center'
      this.prepareWindow(this.$t(title),
        [
          this.saveCenterButton,
          this.saveAndNewCenterButton,
          this.changeCodeButton,
        ])
      if (this.localData.relatedAccountsByLevel) {
        for (var related of this.localData.relatedAccountsByLevel) {
          const relatedAccount = { account: this.getAccountbyId(related.accountId), centerLevel: related.centerLevel, id: related.id }
          if (related.rowState) relatedAccount.rowState = related.rowState
          this.linkedAccounts.push(relatedAccount)
        }
      }
    },
    methods: {
      ...mapActions({
        broadcastRefresh: 'socket/broadcastRefresh',
      }),
      allAcocunts() {
        this.showModal({ component: AccountList, options: { rowSelection: { mode: 'multiRow' }, filterType: 'leaves' } })
          .then((result) => {
            for (const account of result)
              this.linkedAccounts.push({ account })
          }).catch(() => { })
      },
      prepareParentsData(group) {
        var allCenters = this.getAllCenters
        allCenters = allCenters.filter(x => x.hasChild)
        if (group)
          allCenters = allCenters.filter(x => x.group === group)
        if (!isEmpty(this.localData.id))
          allCenters = allCenters.filter(x => x.id !== this.localData.id)
        this.parentsData = allCenters
      },
      clearForm() {
        this.localData = this.data.nodeData
        this.localData.accountingCode = ''
        this.changeCodeButton.disabled = true
        this.getCenterDetails(
          this.localData.accountingCode,
          this.localData.parent
        ).then((res) => this.defer(() => {
          if (!this.localCentergroup)
            this.$refs.CenterGroupDrp.$el.focus()
          else
            this.focusOnInput()
        }, 750))
      },
      metaDataModal() {
        if (!this.localCentergroup)
          return this.$toast(this.$t('meta-data.select-group'))
        this.showModal({
          component: MetaDataSchemaModify,
          options: {
            subject: this.localCentergroup.key,
            title: this.$t(
              'FloatingCenterGroups.' + this.localCentergroup.key.toLowerCase()
            ),
            prefix: 'Center'
          },
        }).then((res) => {
          this.$refs.metaDataList.refresh()
        })
          .catch(() => {

          })
      },
      loadBasedOnCodeInput() {
        if (this.localData.code === this.originalCenter?.code) {
          return
        }
        var newAccountingCode = this.accountingCode.toEnglishDigits()
        var newCenterParent = this.localData.parent

        if (this.isCenterChanged()) {
          dialog({
            title: this.$t('center.m.save.title'),
            body: this.$t('center.m.save.unsaved-changes', {
              code: this.localData.accountingCode,
            }),
            autoClose: true,
            buttons: [
              {
                title: this.$t('dialog.yes'),
                shortcut: $sc.find('yes', 'dialog'),
                isPrimary: true,
                handle: (button, page, e) => {
                  this.localData.code = this.originalCenter.code
                  this.localData.parent = this.originalCenter.parent
                  this.save()
                    .then((res) => {
                      this.getAccountDetails(
                        newAccountingCode,
                        newAccountParent
                      ).then((response) => this.$refs.accountName.$el.focus())
                    })
                    .catch((err) => console.log(err))
                },
              },
              {
                title: this.$t('center.dialog.ignoreChanges-load'),
                shortcut: $sc.find('ignore-changes', 'center'),
                handle: (button, page, e) => {
                  this.getCenterDetails(newAccountingCode, newCenterParent).then(
                    (response) => this.focusOnInput()
                  )
                },
              },
              {
                title: this.$t('dialog.return'),
                shortcut: $sc.find('return', 'dialog'),
                isCancel: true,
                handle: (button, page, e) => {
                  //this.localData.accountingCode = this.originalCenter.accountingCode
                  this.localData.parent = this.originalCenter.parent
                },
              },
            ],
          })
        } else {
          this.getCenterDetails(newAccountingCode, newCenterParent).then((res) =>
            this.defer(() => this.focusOnInput(), 1)
          )
        }
      },
      getCenterDetails(accountingCode, centerParent) {
        return new Promise((resolve, reject) => {
          var wait = this.$wait(this.$refs.code.$el, { size: 'small' })

          if (centerParent) {
            var parentId = centerParent.id
          } else {
            parentId = null
          }

          var centerData = {
            accountingCode,
            parentId,
          }
          var that = this

          post(Endpoints.getUrl('floatingCenters.get-edit-model'), centerData)
            .then((result) => {
              wait.end()

              // temp fix dropdown position
              if (result.data.position === 0) {
                result.data.position = null
              }
              that.localData = _.extendWith({}, result.data, (obj, src, key) => {
                if (key === 'name' && src == null) {
                  return ''
                }

                if (key === 'group' && src === '0') {
                  return null
                }
              })

              that.originalCenter = _.cloneDeep(that.localData)
              that.componentOptions.code.code.level = that.localData.level
              that.priceLevel = isEmpty(that.localData.priceLevelId) ? null : { id: that.localData.priceLevelId }

              this.changeCodeButton.disabled = isEmpty(this.localData.id)
              resolve(that.localData)
            })
            .catch(() => {
              wait.end()
            })
        })
      },
      trySaveLinkedAccounts(floatingCenterId) {
        return new Promise((resolve, reject) => {
          this.$refs.table.commitChanges()
            .then(linkedAccounts => {

              if (!linkedAccounts?.length || linkedAccounts.every(x => x.rowState === 'unchanged')) {
                resolve()
                return
              }

              var errors = []

              const maxCenterLevel = this.getCommercialAccess.customerInformation.maxFlaotingLevel

              for (let index = 0; index < linkedAccounts.length; index++)
                if (linkedAccounts[index].centerLevel > maxCenterLevel)
                  errors.push({ key: 'product', error: this.$t('ceneter.v.ceneterLevel-larger-than-maxCenterLevel', { index }) })

              if (errors.length)
                this.validationToast(errors)
              else {
                var data = {
                  floatingCenterId,
                  accountLevels: linkedAccounts.map(x => {
                    return {
                      id: x.id,
                      rowState: x.rowState,
                      displayOrder: x.displayOrder,
                      centerLevel: x.centerLevel,
                      accountId: x.account.id
                    }
                  })
                }
                post(Endpoints.getUrl('floatingCenters.link-accounts'), data)
                  .then((result) => {
                    this.$toast(this.$t('center.m.save.lta-success'), { type: 'success' })
                    resolve(result)
                  })
                  .catch(err => {
                    this.$toast(this.$t('center.m.save.lta-error'), { type: 'error' })
                    reject(err)
                  })
              }
            })
            .catch(res => reject())
        })
      },
      save() {
        return new Promise((resolve, reject) => {
          var url
          var that = this

          if (this.localData.commissionCalculationType?.key !== undefined) {
            this.localData.commissionCalculationType = this.localData.commissionCalculationType.key
          }
          this.localData.fixAmountOfCommission = Number(this.localData.fixAmountOfCommission) || 0
          this.localData.fixPercentageOfCommission = Number(this.localData.fixPercentageOfCommission) || 0

          if (isEmpty(this.localData.id)) {
            url = Endpoints.getUrl('floatingCenters.create')
          } else {
            url = Endpoints.getUrl('floatingCenters.update')
          }

          this.localData.metaDatas = this.$refs.metaDataList.commitData()
          if (this.validateInputs()) {
            this.localData.accountingCode = this.accountingCode.toEnglishDigits()
            if (this.priceLevel)
              this.localData.priceLevelId = this.priceLevel.id
            var data = {
              imageFileBase64: this.$refs.imageUploader.hasFile() ? this.$refs.imageUploader.getUploadImageDataBase64() : undefined,
              floatingCenter: this.localData,
              checkWarning: true
            }
            var wait = this.$wait(this.$el)
            this.defer(() => post(url, data)
              .then((result) => {

                const newId = result.data.floatingCenterId

                if (that.data.state === 'add-root') {
                  that.data.nodeData.id = newId
                  that.data.nodeData.parent = null
                } else if (that.data.state === 'add-child') {
                  that.data.nodeData.id = newId
                  that.data.nodeData.parent = { id: that.data.parentData.id, name: that.data.parentData.name, accountingCode: that.data.parentData.accountingCode }
                  that.data.parentData.hasChild = true
                }

                if (result.success) {
                  that.localData.id = newId
                  that.originalCenter = null
                  this.$toast(that.$t('center.m.save.success'), { type: 'success' })
                  this.trySaveLinkedAccounts(newId)
                    .then(res => { resolve(this.localData) })
                    .catch(err => { })
                    .finally(() => {
                      // this.broadcastRefresh('FloatingCenters')
                      this.broadcastRefresh('Accounts')
                      this.broadcastRefresh('AutoAccount')
                      wait.end()
                    })
                } else {
                  reject()
                }
              })
              .catch(() => {
                wait.end()
                reject()
              }), 500)
          } else {
            reject()
          }
        })
      },
      validateInputs() {
        let checker = new Checker((field) =>
          this.$t(`center.f.${field}`)
        )
        let errors = checker.test(this.localData, this.validators)

        if (this.isPersonnel && this.localData.marketingRoles.length > 0) {
          if (!this.localData.commissionCalculationType) {
            errors.push({
              key: 'commissionCalculationType',
              error: this.$t('center.f.commissionCalculationType.title') + this.$t('msg.required')
            })
          }
        }
        if (this.localData.commissionCalculationType === 'FixPercentage' && this.localData.fixPercentageOfCommission === 0) {
          errors.push({
            key: 'fixPercentageOfCommission',
            error: this.$t('center.m.fix-Percentage-required')
          })
        }
        if (this.localData.commissionCalculationType === 'FixAmount' && this.localData.fixAmountOfCommission === 0) {
          errors.push({
            key: 'fixAmountOfCommission',
            error: this.$t('center.m.fix-Amount-required')
          })
        }

        let metaDataChecker = new MetaDataChecker()
        const metaDataErrors = metaDataChecker.test(this.localData.metaDatas, this.metaDataValidators)

        errors.push(...metaDataErrors)
        this.validationToast(errors)
        return errors.length === 0
      },
      isCenterChanged() {
        var clone = _.cloneDeep(this.localData)
        clone.code = this.originalCenter.code
        return !_.isEqualWith(this.originalCenter, clone, (orig, loc, key) => {
          if (key === 'valid' || key === 'dirtyCells') {
            return true
          } else if (key && !orig && !loc) {
            return true
          }
        })
      },
      allCenters() {
        var that = this

        this.showModal({
          component: centerSelector,
          options: { filterType: 'all', selected: that.localData, filterByGroup: this.settings.group },
        })
          .then((result) => {
            if (result) {
              that
                .getCenterDetails(result.accountingCode, result.parent)
                .then((res) => this.defer(() => this.focusOnInput(), 1))
            }
          })
          .catch(() => {
            this.$refs.focusOnInput()
          })
      },
      hasRole(role) {
        return this.localData.marketingRoles?.includes(role)
      },
      toggleRole(role, checked) {
        const selectedRoles = this.localData.marketingRoles || []
        this.localData.marketingRoles = checked ? [...new Set([...selectedRoles, role])] : selectedRoles.filter(r => r != role)
      },
      getProperties() {
        return new Promise((resolve, reject) => {
          this.cache_getOrSet(`properties_key`, 0, () => {
            return this.allProperties
            // return this.downloadProperties()
          })
            .then((result) => {
              this.centerGroups = result.filter(
                (x) => x.group === 'FloatingCenterGroups' && this.$nikan.checkPermission(`Accounting_FloatingCenterGroups_${x.key}`)
              )
              if (this.settings.group.length) {
                this.centerGroups = this.centerGroups.filter(x => this.settings.group.indexOf(x.name) > -1)
                this.defer(() => {
                  if (this.centerGroups.length === 1)
                    this.localCentergroup = this.centerGroups[0]
                }, 200)
              }
              resolve(result)
            })
            .catch((cerror) => {
              reject(cerror)
              alert('could not fetch Properties')
            })
        })
      },
      downloadProperties() {
        return new Promise((resolve, reject) => {
          post(Endpoints.getUrl('general.getAllProperties'))
            .then((result) => {
              resolve(result.data.items)
            })
            .catch((error) => {
              reject(error.message)
            })
        })
      },
      parentChanged(parent) {
        if (this.retreiveIsEmpty()) {
          this.getCenterDetails(
            this.localData.accountingCode,
            parent
          ).then((res) => { })
        }
      },
      centerCodeBlur() {
        if (this.originalCenter && !this.onCodeEnterPressed) {
          this.loadBasedOnCodeInput()
        }
        this.onCodeEnterPressed = false
      },
      retreiveIsEmpty() {
        return isEmpty(this.localData.id)
      },
      focusOnInput() {
        if (!this.localCentergroup)
          this.$refs.CenterGroupDrp.$el.focus()
        else
          this.$refs.centerName.$el.focus()
      },
      subscribeKeys() {
        this.$keyHandler.Subscribe({
          name: 'center-code-enter',
          keyCode: 13,
          el: this.$refs.code.$el,
          context: this,
          handler: function (el, e) {
            this.onCodeEnterPressed = true
            this.loadBasedOnCodeInput()
          },
        })
      },
    },
  }
</script>
<style>
  .floating-center-input .m-dropdown.floating-center-group-drop {
    flex-grow: 2;
  }

  .image-container {
    margin-bottom: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  @media screen and (max-width: 767px) {
    .mobile {
      flex-direction: column-reverse !important;
    }

    .nk-page .nk-seprator::after {
      display: none;
    }

    .image-container {
      margin-right: auto;
      margin-left: auto;
    }
  }
</style>
